module.exports = __webpack_public_path__ + "img/turn-on-off.5defcfa2.svg";